const getURLForBasePage = () => {
  return "/";
};

export const urlHelper = {
  getURLForBasePage,
};
